import { render, staticRenderFns } from "./PrintJournalSettlementDriver.vue?vue&type=template&id=b2db48a6"
import script from "./PrintJournalSettlementDriver.vue?vue&type=script&lang=js"
export * from "./PrintJournalSettlementDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports